export default __webpack_public_path__ + "static/elysian_island_weed_farm-b739d1fb145d2fac696cce27b976f73e.png";